import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Склейка классов с разрешением конфликтов Tailwind.
 *
 * Нужна компонентам из ui/: она даёт возможность передать className извне
 * и переопределить класс из варианта, а не получить оба сразу.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
